import * as React from "react"

import {Box, useTheme} from "@mui/material";


export default function RatingScore({ ratingScore, totalRatings }) {
    return <Box fontSize={1} >
        { 5 in ratingScore && <RatingScoreBlock key={5} num={5} score={ratingScore[5] || 0} numTotal={totalRatings} />}
        { 2 in ratingScore && <RatingScoreBlock key={4} num={4} score={ratingScore[4] || 0} numTotal={totalRatings} />}
        { 3 in ratingScore && <RatingScoreBlock key={3} num={3} score={ratingScore[3] || 0} numTotal={totalRatings} />}
        { 2 in ratingScore && <RatingScoreBlock key={2} num={2} score={ratingScore[2] || 0} numTotal={totalRatings} />}
        { 1 in ratingScore && <RatingScoreBlock key={1} num={1} score={ratingScore[1] || 0} numTotal={totalRatings} />}
    </Box>
}

const RatingScoreBlock = ({ num, score, numTotal}) => {
    const { palette } = useTheme()

    let percentageWidth = Math.round(score * 100 / numTotal)
    if ( score > 0 && percentageWidth < 2 ) percentageWidth = 2

    return <Box sx={{ display: "flex", flexWrap: "wrap", mt: .5 }} >
        <Box sx={{ flex: "2%", fontWeight: 'bold' }}>{num}</Box>
        <Box sx={{ backgroundColor: palette.secondary.light, borderRadius: '999px', flex: "90%", mr: "1%" }}>
            <Box sx={{ height: "100%", borderRadius: '999px', width: `${percentageWidth}%`, backgroundColor: 'warning.main' }} />
        </Box>
        <Box sx={{ flex: "5%" }}>
            ({score})
        </Box>
    </Box>
}
